import { AbstractControl } from '@angular/forms';
import { calculateAge, dobRegex } from './util';

export default function maxCharacterCount(char: string, count: number) {
  return (control: AbstractControl) => {
    if (control && control.value) {
      const value = control.value as string;
      const tokens = value.split(char);
      if (tokens.length > count + 1) {
        return {
          maxCharacterCount: true,
        };
      }
    }
    return null;
  };
}
